import type { IParticipantsStat } from '@/api/endpoints/schools/schoolParticipants';

export const getStatCardsData = ({ participantsStat }: { participantsStat: IParticipantsStat }) => {
  const { total, pending_authorization: pendingAuthorization, accepted } = participantsStat;

  return [
    {
      id: 1,
      title: 'Всего участников',
      value: total,
      cardTheme: 'base',
    },
    {
      id: 2,
      title: 'Ожидают авторизацию',
      value: pendingAuthorization,
      cardTheme: 'green',
    },
    {
      id: 3,
      title: 'Зачислено',
      value: accepted,
      cardTheme: 'yellow',
    },
  ];
};
